import { FormGroup, Label } from 'reactstrap'
import Select from 'react-select'
import PropTypes from 'prop-types'

const FormSelect = ({
  name,
  label,
  options = [],
  onChange,
  onBlur = () => {},
  required,
  disabled = false,
  defaultValue,
  value,
  placeholder = '',
}) => {
  return (
    <FormGroup>
      <Label for={name}>
        {label} {required ? <b>*</b> : null}
      </Label>
      <Select
        name={name}
        id={name}
        options={options}
        onChange={onChange}
        required={required}
        isDisabled={disabled}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        onBlur={onBlur}
      />
    </FormGroup>
  )
}

FormSelect.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
}

export default FormSelect
